(function () {
  const relatedCollectionsTrackEl = document.querySelector(
    ".related-collections__track"
  );

  if (relatedCollectionsTrackEl) {
    const relatedCollectionsNextBtnEl = document.querySelector(
      ".related-collections__next"
    );
    const relatedCollectionsPrevBtnEl = document.querySelector(
      ".related-collections__prev"
    );
    let currentScrollValue = 0;

    const relatedCollectionsInit = () => {
      relatedCollectionsNextBtnEl.addEventListener("click", () => {
        handleBtnClick("next");
      });

      relatedCollectionsPrevBtnEl.addEventListener("click", () => {
        handleBtnClick("prev");
      });
    };

    const handleBtnClick = (type) => {
      const currentScroll = relatedCollectionsTrackEl.scrollLeft;
      const relatedCollectionsItems =
        relatedCollectionsTrackEl.querySelectorAll(
          ".related-collections__item"
        );

      if (type == "next") {
        relatedCollectionsPrevBtnEl.disabled = false;
        for (let i = 0; i < relatedCollectionsItems.length; i++) {
          const containerRect =
            relatedCollectionsTrackEl.getBoundingClientRect();
          const itemRect = relatedCollectionsItems[i].getBoundingClientRect();

          const targetScrollLeft =
            itemRect.left - containerRect.left + currentScroll;

          if (targetScrollLeft > currentScroll) {
            relatedCollectionsTrackEl.scrollTo({
              left: targetScrollLeft,
              behavior: "smooth",
            });

            break;
          }
        }
      } else if (type == "prev") {
        relatedCollectionsNextBtnEl.disabled = false;
        for (let i = relatedCollectionsItems.length - 1; i >= 0; i--) {
          const containerRect =
            relatedCollectionsTrackEl.getBoundingClientRect();
          const itemRect = relatedCollectionsItems[i].getBoundingClientRect();
          const targetScrollLeft =
            itemRect.left - containerRect.left + currentScroll;

          if (targetScrollLeft < currentScroll) {
            relatedCollectionsTrackEl.scrollTo({
              left: targetScrollLeft,
              behavior: "smooth",
            });

            break;
          }
        }
      }
    };

    const updateButtonStates = () => {
      const currentScroll = relatedCollectionsTrackEl.scrollLeft;
      const containerWidth = relatedCollectionsTrackEl.clientWidth;
      const scrollWidth = relatedCollectionsTrackEl.scrollWidth;

      // Disable prev button if we are scrolled to the beginning
      if (currentScroll <= 0) {
        relatedCollectionsPrevBtnEl.disabled = true;
      } else {
        relatedCollectionsPrevBtnEl.disabled = false;
      }

      // Disable next button if we have reached (or are near) the end
      if (currentScroll + containerWidth >= scrollWidth) {
        relatedCollectionsNextBtnEl.disabled = true;
      } else {
        relatedCollectionsNextBtnEl.disabled = false;
      }
    };

    relatedCollectionsTrackEl.addEventListener("scroll", updateButtonStates);
    window.addEventListener("resize", updateButtonStates);
    document.addEventListener("DOMContentLoaded", updateButtonStates);
    document.addEventListener("shopify:section:load", relatedCollectionsInit());
  }

  // Featured collection slider, still using Splide
  const featuredCollectionSlider = document.querySelector(
    ".splide.featured-collections"
  );
  if (featuredCollectionSlider) {
    const relatedCollectionsInit = () => {
      const relatedCollectionsSliderEl = featuredCollectionSlider;

      const splide = new Splide(relatedCollectionsSliderEl, {
        perPage: 4,
        pagination: false,
        gap: "2.8rem",
        breakpoints: {
          990: {
            gap: "1.4rem",
          },
          768: {
            perPage: 2,
          },
          500: {
            perPage: 1,
          },
        },
      });

      splide.mount();
    };

    document.addEventListener("shopify:section:load", relatedCollectionsInit());
    document.addEventListener("DOMContentLoaded", relatedCollectionsInit());
  }
})();
